import React, { useEffect, useState } from 'react';
import Auxiliary from 'hoc/Auxiliary';
import FuelVendorSummary from './FuelVendorSummary/FuelVendorSummaryGrid';
import { withStyles } from '@material-ui/core';
import SnackbarFuelVendor from '../UI/Snackbar/TSnackbar';
import CustomHeader from '../CustomHeader/CustomHeader';
import { connect } from 'react-redux';
import { FUELVENDORSUMMARY } from 'constants/Constants';
import { setCurrentPage } from 'store/actions';
import { isNotBlank } from 'components/Common/Utils/StringUtils';

const styles = (theme) => ({
    customRoot: {
        height: 830,
        backgroundColor: '#F3F3F7',
        padding: '20px 50px'
    }
});

const FuelVendor = (props) => {
    const { classes, session, setCurrentPage, parentPage } = props;

    const [sessionValue, setSessionValues] = useState({
        isCarrier: session.isCarrier,
        userId: session.userId,
        isSystemAdmin: session.userRole === 'SYSTEM_ADMIN',
        accountId: session.selected_accountId ? session.selected_accountId : session.accountId
    });

    useEffect(() => {
        if (isNotBlank(parentPage)) {
            setCurrentPage(parentPage);
        } else {
            setCurrentPage(FUELVENDORSUMMARY);
        }
    }, [setCurrentPage]);

    useEffect(() => {
        setSessionValues({
            isCarrier: session.isCarrier,
            userId: session.userId,
            isSystemAdmin: session.userRole === 'SYSTEM_ADMIN',
            accountId: session.selected_accountId ? session.selected_accountId : session.accountId
        });
    }, [session]);

    return (
        <Auxiliary>
            <Auxiliary>
                <CustomHeader title="FUEL CARD PARTNERS" />
            </Auxiliary>
            <div className={classes.root}>
                <FuelVendorSummary sessionValue={session} />
                <SnackbarFuelVendor />
            </div>
        </Auxiliary>
    );
};

const mapStateToProps = (state) => ({
    session: state.session.sessionValue
});

export default connect(mapStateToProps, {
    setCurrentPage
})(withStyles(styles)(FuelVendor));
